const config = {
    appConfig: {},
    rbacAPI: process.env.REACT_APP_RBAC_API,
    appAPI: process.env.REACT_APP_API
};

module.exports = config;
